import React from 'react'
import ReactDOM from 'react-dom'

export default function Nav2() {
    return (
        <div>Nav #2</div>
    )
}
